import {nioJsBridge} from 'nioJsBridge';

const checkOSInfo = os => {
  let result = false;

  if (nioJsBridge && nioJsBridge.getOSInfo){
    const {data} = nioJsBridge.getOSInfo();

    result = data.systemName === os;
  }
  return result;
};

export const isAndroid = (useNative = true) => (useNative ? checkOSInfo('android') : !!window.navigator.userAgent.match(/Android|Adr/i));

export const isIOS = (useNative = true) => (useNative ? checkOSInfo('iOS') : !!window.navigator.userAgent.match(/iPhone|iPad|iPod|Mac OS/i));

export const isMobileQQ = () => /QQBrowser/i.test(window.navigator.userAgent);

export const isMobileUC = () => /UCBrowser/i.test(window.navigator.userAgent);

export const isWx = () => !!window.navigator.userAgent.match(/micromessenger/i);

export const isWeibo = () => !!window.navigator.userAgent.match(/WeiBo/i);

export const checkAppVersion = (ver1 = '', ver2 = '') => {
  let result = 0;

  if (`${ver1}` === `${ver2}`){
    return result;
  } if (`${ver1}` !== ''){
    let v1 = `${ver1}`.split('.');
    let v2 = `${ver2}`.split('.');

    v1.every((i, index) => {
      if (typeof v2[index] === 'undefined' || Number(i) > Number(v2[index])){
        result = 1;
        return false;
      } if (Number(i) < Number(v2[index])){
        result = -1;
        return false;
      }
      return true;
    });
    return result;
  }
  return -1;
};